/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_helpers";
import {Alert } from "react-bootstrap";

export const FeedKycPending = (props) => {

    return (
                <>
                <div className="row align-content-start position-relative" style={{minHeight: "74vh"}}>
                    <div className="col-12">
                       <h3>Diamond Feed Center</h3>
                       <Alert className="my-5" variant="danger">
                       Your update profile is under review.
                        </Alert>
                        <Alert className="my-5" variant="danger">
                        Dont Worry, Your Diamond Feed will start exactly from where you stopped.
                        </Alert>
                    </div>
                    <div className="api-home-svg api-failed"><SVG src={toAbsoluteUrl("/media/General/diamond_feed_request.svg")} /></div>
                </div>
            </>
    );
};
